import React from "react";
import MtiButton from "../../Buttons/MtiButton";
import "./ToolsGeneral.css";


type SwitchProps = {
  isOn: boolean;
  onTrigger: () => void;
};

const SwitchTrigger = ({ isOn, onTrigger }: SwitchProps) => {
  return (
    <>
      {isOn && (
        <svg
          onClick={onTrigger}
          style={{cursor: "pointer"}}
          width="74"
          height="32"
          viewBox="0 0 74 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="74" height="32" rx="16" fill="#006AF5" />
          <circle cx="58" cy="16" r="12" fill="white" />
        </svg>
      )}
      {!isOn && (
        <svg
          onClick={onTrigger}
          style={{cursor: "pointer"}}
          width="74"
          height="32"
          viewBox="0 0 74 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="74" height="32" rx="16" fill="#999999" />
          <circle cx="16" cy="16" r="12" fill="white" />
        </svg>
      )}
    </>
  );
};

type Props = {
  title: string;
  type: "button" | "switch";
  onActionTrigger: () => void;
  buttonText?: string;
  isOnTrigger?: boolean;
  style?: React.CSSProperties;
};

export default function GeneralListAction({
  title,
  type,
  onActionTrigger,
  buttonText,
  isOnTrigger = false,
  style,
}: Props) {
  let actionTrigger = null;

  if (type === "button") {
    actionTrigger = (
      <MtiButton
        variant={"primary"}
        colorVariant={"black"}
        onClick={onActionTrigger}
        style={{
          height: 34,
          paddingLeft: 16,
          paddingRight: 16,
        }}
      >
        {buttonText}
      </MtiButton>
    );
  }

  if (type === "switch") {
    actionTrigger = (
      <SwitchTrigger isOn={isOnTrigger} onTrigger={onActionTrigger} />
    );
  }

  return (
    <div className="tools-general-list-action" style={style}>
      <div>{title}</div>
      <div>{actionTrigger}</div>
    </div>
  );
}
